var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("VerReportePorUnidadGestion"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("event")]),
          _vm._v(" Programación de vacaciones\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            { staticClass: "grey lighten-2 text--info" },
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c("v-flex", { staticClass: "px-2" }, [
                    _c("strong", [_vm._v("DEPENDENCIA: ")]),
                    _vm._v(_vm._s(_vm.dependencia) + "\n        ")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c("crud-table", {
                staticClass: "elevation-1 tabla-comprimida-light",
                attrs: {
                  headers: _vm.headers,
                  url: _vm.url,
                  filters: _vm.filters,
                  "data-graphql": _vm.dataGraphql,
                  graphql: _vm.graphql,
                  initData: _vm.initData
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(items) {
                      return [
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.gestion))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm
                                  .$moment(items.item.fecha_inicio)
                                  .format("DD/MM/YYYY")
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm
                                  .$moment(items.item.fecha_fin)
                                  .format("DD/MM/YYYY")
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm
                                  .$moment(items.item.fecha_corte)
                                  .format("DD/MM/YYYY")
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.porcentaje) + "%")
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "nowrap text-xs-center" },
                          [
                            _vm.gestion_actual != items.item.gestion
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "info",
                                      to:
                                        "vacaciones-aprobar-jefe-inmediato/" +
                                        items.item.gestion,
                                      icon: "",
                                      title: "Ver programaciones de vacación"
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("remove_red_eye")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.gestion_actual == items.item.gestion
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "info",
                                      to:
                                        "vacaciones-aprobar-jefe-inmediato/" +
                                        items.item.gestion,
                                      icon: "",
                                      title: "Ver programaciones de vacación"
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("list ")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "warning",
                                  icon: "",
                                  title: "Ver reporte de vacación"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.verReportePorUnidadGestion(
                                      items.item,
                                      1
                                    )
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("picture_as_pdf")])],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d6dcdbb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d6dcdbb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacaciones/ListadoGestionesPorServidor.vue
// module id = null
// module chunks = 